import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { post } from '../../api/client'
import { Button, ErrorNote } from '../../components/ui'

export function UnsubscribePage() {
  const { token } = useParams()
  const [done, setDone] = useState(false)
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const go = async () => {
    if (!token) return
    setPending(true)
    try { await post(`/api/public/avregistrera/${token}`); setDone(true) } catch (e) { setError(e) } finally { setPending(false) }
  }
  return (
    <div className="card p-8 text-center">
      <h1 className="text-xl">{done ? 'Du är avregistrerad' : 'Avregistrera dig från eventinbjudningar'}</h1>
      <p className="mt-2 text-sm text-ink-500">
        {done ? 'Du kommer inte att få fler eventinbjudningar från Söderberg & Partners Wealth Management.' : 'Du får då inga fler inbjudningar till kundevent via e-post. Din rådgivare kan fortfarande kontakta dig direkt.'}
      </p>
      <ErrorNote error={error} />
      {!done && token && <Button variant="danger" className="mt-5" loading={pending} onClick={go}>Avregistrera mig</Button>}
      {!token && <p className="mt-4 text-xs text-ink-400">Ingen giltig länk. Använd länken i mejlet.</p>}
    </div>
  )
}
